import starRating from "star-rating-svg/src/jquery.star-rating-svg";
import IMask from "imask";

window.starRating = starRating;
$(function () {
    $('[data-toggle="tooltip"]').tooltip();

    const detailsNavOffset = $('nav.navbar.navbar-expand-lg').innerHeight(); //Previous value: 60

    $('.product-details-nav-container:not(.tabbed) a.nav-link').click(function (e) {
        e.preventDefault();
        $($(this).attr('href'))[0].scrollIntoView();
        window.location.hash = $(this).attr('href')
        scrollBy(0, -detailsNavOffset);
    });

    let addToCartForm = $('#add-to-cart');
    let productPrices = $('.product-prices');

    function updatePrice(data) {
        productPrices.find('.regular-prices').toggleClass('d-none', !data['has_discount']);
        productPrices.find('.current-prices .price').html(data['total_price_formatted']);
        productPrices.find('.current-prices .price-with-vat').html(data['total_price_with_vat_formatted']);
        productPrices.find('.current-prices .single-price').html(data['single_price_formatted']);
        productPrices.find('.regular-prices .price').html(data['regular_total_price_formatted']);
        productPrices.find('.regular-prices .single-price').html(data['regular_single_price_formatted']);
    }

    function fetchPrice() {
        $.post({
            url: '/api/product/calculate-price',
            data: addToCartForm.serializeArray()
        }).done(function (data, textStatus, jqXHR) {
            updatePrice(data);
        }).fail(function (jqXHR, textStatus, errorThrown) {
            console.log(jqXHR.responseJSON);
            console.log(textStatus);
            console.log(errorThrown);
        });
    }

    addToCartForm.find(':input:not([name="quantity"])').each(function () {
        $(this).change(function () {
            fetchPrice();
        });
    });

    $.each($('.quantity-input-int'), function (index, value) {
        IMask(value, {
            mask: Number,
            min: 0,
            scale: 0,
            signed: false,
            thousandsSeparator: '',
            padFractionalZeros: true,
            normalizeZeros: true,
            radix: '.',
            mapToRadix: [','],
        });
    });

    const previewGallery = $('.product-gallery-preview');
    const productGallery = $('#product-gallery');
    const galleryModal = $('#gallery-modal');
    const productGalleryModal = $('#product-gallery-modal');
    const radioText = $('.radio-text-customization');

    radioText.find('input:radio').change(function () {
        $(this).closest('.radio-text-customization').find('textarea').toggleClass('d-none', $(this).val() === '0')
    })

    function showModalWithSlide(slideNumber) {
        productGalleryModal.closest('.gallery-container').find(`.thumbnail[data-slide-to='${slideNumber}']`).addClass('active border-info');
        galleryModal.modal('show');
        productGallery.carousel('pause');
        productGalleryModal.carousel(slideNumber);
    }

    productGallery.closest('.gallery-container').find('.thumbnail').on('click', function () {
        showModalWithSlide($(this).data('slide-to'));
    });

    productGallery.find('.carousel-item').on('click', function () {
        showModalWithSlide($(this).data('slide-to'));
    });

    productGallery.closest('.gallery-container').find('.product-gallery-preview').on('mouseenter mouseleave', '[data-slide-to]', function (e) {
        if (e.type === 'mouseenter') {
            $(this).addClass('active').css('cursor', 'pointer');
            const hoveredSlideIndex = $(this).data('slide-to');
            const currentActiveSlideIndex = productGallery.find('.carousel-item.active').index();
            
            // Only pause video if hovering over a different thumbnail
            if (hoveredSlideIndex !== currentActiveSlideIndex) {
                // Pause any currently playing video
                const currentActiveVideo = productGallery.find('.carousel-item.active video.product-video')[0];
                if (currentActiveVideo && !currentActiveVideo.paused) {
                    currentActiveVideo.pause();
                }
            }
            $(this).closest('.gallery-container').find('.product-gallery').carousel(hoveredSlideIndex);
        } else if (e.type === 'mouseleave') {
            $(this).removeClass('active').css('cursor', 'auto');
        }
    });

    productGallery.on('slide.bs.carousel', function (e) {
        previewGallery.find('[data-slide-to="' + e.from + '"]').removeClass('active');
        previewGallery.find('[data-slide-to="' + e.to + '"]').addClass('active');
        
        // Pause video in the slide that's being hidden
        const fromSlide = $(this).find('.carousel-item').eq(e.from);
        const video = fromSlide.find('video.product-video')[0];
        if (video && !video.paused) {
            video.pause();
        }
    });

    productGallery.on('slid.bs.carousel', function (e) {
        // After slide transition completes, ensure only active video plays
        $(this).find('.carousel-item').each(function(index) {
            const isActive = $(this).hasClass('active');
            const video = $(this).find('video.product-video')[0];
            if (video) {
                if (isActive) {
                    // Play the active video
                    const playPromise = video.play();
                    if (playPromise !== undefined) {
                        playPromise.catch(error => {
                            // Autoplay was prevented, which is expected on some browsers
                            console.log('Video autoplay prevented:', error);
                        });
                    }
                } else {
                    // Pause non-active videos to save bandwidth
                    if (!video.paused) {
                        video.pause();
                    }
                }
            }
        });
    });

    galleryModal.on('shown.bs.modal', function () {
        // Ensure the active video in the modal is playing when it opens
        const activeVideo = productGalleryModal.find('.carousel-item.active video.product-video')[0];
        if (activeVideo) {
            const playPromise = activeVideo.play();
            if (playPromise !== undefined) {
                playPromise.catch(error => {
                    console.log('Video autoplay prevented in modal:', error);
                });
            }
        }
    });
    
    galleryModal.on('hidden.bs.modal', function () {
        productGallery.carousel('cycle');
        productGalleryModal.closest('.gallery-container').find('.thumbnail').removeClass(['active', 'border-info']);
        // Pause all videos in modal to save bandwidth
        productGalleryModal.find('video.product-video').each(function() {
            const video = this;
            if (!video.paused) {
                video.pause();
            }
        });
    });

    productGalleryModal.closest('.gallery-container').find('.thumbnail').on('click', function () {
        if (!$(this).hasClass('border-info')) {
            $(this).addClass('active border-info');
        }
        $('.thumbnail').not(this).removeClass(['active', 'border-info']);
        
        const clickedSlideIndex = $(this).data('slide-to');
        const currentActiveSlideIndex = productGalleryModal.find('.carousel-item.active').index();
        
        // Only pause video if clicking on a different thumbnail
        if (clickedSlideIndex !== currentActiveSlideIndex) {
            // Pause any currently playing video
            const currentActiveVideo = productGalleryModal.find('.carousel-item.active video.product-video')[0];
            if (currentActiveVideo && !currentActiveVideo.paused) {
                currentActiveVideo.pause();
            }
        }
        
        productGalleryModal.carousel(clickedSlideIndex);
    });

    // Pause videos in modal gallery when slides change
    productGalleryModal.on('slide.bs.carousel', function (e) {
        const fromSlide = $(this).find('.carousel-item').eq(e.from);
        const video = fromSlide.find('video.product-video')[0];
        if (video && !video.paused) {
            video.pause();
        }
    });

    productGalleryModal.on('slid.bs.carousel', function (e) {
        $(this).find('.carousel-item').each(function(index) {
            const isActive = $(this).hasClass('active');
            const video = $(this).find('video.product-video')[0];
            if (video) {
                if (isActive) {
                    // Play the active video
                    const playPromise = video.play();
                    if (playPromise !== undefined) {
                        playPromise.catch(error => {
                            console.log('Video autoplay prevented in modal:', error);
                        });
                    }
                } else {
                    // Pause non-active videos to save bandwidth
                    if (!video.paused) {
                        video.pause();
                    }
                }
            }
        });
    });

    productGalleryModal.closest('.gallery-container').find('.thumbnail').on('mouseenter mouseleave', function (e) {
        if (e.type === 'mouseenter') {
            $(this).addClass('active').css('cursor', 'pointer');
        } else if (e.type === 'mouseleave') {
            if (!$(this).hasClass('border-info')) {
                $(this).removeClass('active');
            }
            $(this).css('cursor', 'auto');
        }
    });

    const decQtyBtn = $('.prod-qty-dec');
    const incQtyBtn = $('.prod-qty-inc');
    const qtyInput = $('input[name="quantity"]');
    const overlay = $('.cart-container .cart-overlay').first();

    decQtyBtn.click(function () {
        changeQuantity(this, -1);
    });

    incQtyBtn.click(function () {
        changeQuantity(this, 1);
    });

    qtyInput.focusout(function (e) {
        changeQuantity(this, 0);
    })

    function changeQuantity(element, step) {
        const form = $(element).closest('form');
        const qtyInput = form.find('input[name=quantity]');
        const qtyInputMinValue = parseInt(qtyInput.attr('min'));
        let value = parseInt(qtyInput.val());
        if (step === -1 && value <= qtyInputMinValue) {
            return;
        } else if (step === 0 && (!value || value < qtyInputMinValue)) {
            value = qtyInputMinValue;
        }

        qtyInput.val(value + step);
        fetchPrice();
    }

    $(".my-rating").starRating({
        starSize: 25,
        useFullStars: true,
        disableAfterRate: false,
        callback: function (currentRating, element) {
            $('.rating-input').val(currentRating);
        }
    });
    $(".user-rating").starRating({
        starSize: 20,
        readOnly: true
    });
});
